import React from 'react';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { DashboardClaimsTab } from 'locales/en';

interface ClaimsTabsProps {
  activeTab: string;
  setActiveTab: (key: DashboardClaimsTab) => void;
}

const ClaimsTabs: React.FC<ClaimsTabsProps> = ({ activeTab, setActiveTab }) => {
  const { t } = useTranslation();

  const claimsTabs = [
    {
      key: DashboardClaimsTab.AllMaster,
      label: (
        <span className="flex gap-2 items-center">
          {t('dashboard.claimsTabs.allMaster')}
        </span>
      ),
    },
    {
      key: DashboardClaimsTab.AllBinder,
      label: (
        <span className="flex gap-2 items-center">
          {t('dashboard.claimsTabs.allBinder')}
        </span>
      ),
    },
  ];

  return (
    <div className="bg-[#E3F2FB] rounded-xl w-fit mb-3">
      <Tabs
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key as DashboardClaimsTab)}
        items={claimsTabs}
        className="custom-tabs uw-custom-tabs ant-tabs-tab"
        tabBarGutter={8}
        tabBarStyle={{ margin: 0 }}
      />
    </div>
  );
};

export default ClaimsTabs;
